import React, { useState, useEffect } from "react";
import styles from "./Carousel.module.scss";

interface CarouselProps {
  items: React.ReactNode[];
  className?: string;
}

export const Carousel: React.FC<CarouselProps> = ({ items, className }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev + 1) % items.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev - 1 + items.length) % items.length);
  };

  const goToSlide = (index: number) => {
    setCurrentIndex(index);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 6000);

    return () => clearInterval(interval);
  }, [items.length, currentIndex]);

  if (!items || items.length === 0) {
    return null;
  }

  return (
    <div className={className}>
      <div className={styles["carousel-container"]}>
        <button
          className={`${styles["nav-button"]} ${styles["desktop-only"]}`}
          onClick={prevSlide}
          aria-label="Previous slide">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round">
            <polyline points="15 18 9 12 15 6" />
          </svg>
        </button>

        <div className={styles["carousel-track-container"]}>
          <div
            className={styles["carousel-track"]}
            style={{ transform: `translateX(-${currentIndex * 100}%)` }}>
            {items.map((item, index) => (
              <div key={index} className={styles["carousel-slide"]}>
                {item}
              </div>
            ))}
          </div>
        </div>

        <button
          className={`${styles["nav-button"]} ${styles["desktop-only"]}`}
          onClick={nextSlide}
          aria-label="Next slide">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round">
            <polyline points="9 18 15 12 9 6" />
          </svg>
        </button>
      </div>

      <div className={styles["carousel-controls-mobile"]}>
        <button
          className={styles["nav-button-mobile"]}
          onClick={prevSlide}
          aria-label="Previous slide">
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round">
            <polyline points="15 18 9 12 15 6" />
          </svg>
        </button>

        <div className={styles["carousel-dots"]}>
          {items.map((_, index) => (
            <div
              key={index}
              className={`${styles["dot"]} ${
                index === currentIndex ? styles["active"] : ""
              }`}
              onClick={() => goToSlide(index)}
            />
          ))}
        </div>

        <button
          className={styles["nav-button-mobile"]}
          onClick={nextSlide}
          aria-label="Next slide">
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round">
            <polyline points="9 18 15 12 9 6" />
          </svg>
        </button>
      </div>
    </div>
  );
};
